// GENERATED by scripts/icons/generate_icons.py. Do not edit by hand.
import { createIcon } from "./createIcon";

export const PlayCircleIcon = /*#__PURE__*/ createIcon("PlayCircle", "M9.13 7.18A.75.75 0 0 0 8 7.83v4.34c0 .57.63.94 1.13.65l4.12-2.39a.5.5 0 0 0 0-.86zM2 10a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-7a7 7 0 1 0 0 14 7 7 0 0 0 0-14");
